var _g, _g2, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 214,
    viewBox: "0 0 201 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plant"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.688 99.7809C174.063 107.17 170.375 116.142 170.375 116.142L149.307 95.0314C149.307 95.0314 159.314 92.3919 166.688 99.7809ZM170.374 116.143C170.374 116.143 160.894 119.31 154.046 112.449C147.2 105.588 149.305 95.0328 149.305 95.0328L170.374 116.143Z",
    fill: "url(#scanning0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.33 113.048C169.33 113.048 165.769 102.381 173.486 94.6774C181.204 86.9735 193.077 89.344 193.077 89.344C193.077 89.344 196.037 100.596 187.734 108.899C184.193 112.441 180.243 113.546 177.103 114.424C173.734 115.366 171.297 116.048 171.297 119.197V123.84H168.51V116.162C168.51 114.808 169.002 113.506 169.886 112.494L169.33 113.048Z",
    fill: "url(#scanning1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.362 143.565H156.012C154.626 143.565 153.454 142.423 153.271 140.894L151.629 127.199C151.201 123.627 153.99 120.485 157.587 120.485H182.787C186.384 120.485 189.173 123.627 188.745 127.199L187.103 140.894C186.92 142.423 185.748 143.565 184.362 143.565Z",
    fill: "url(#scanning2_linear)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "arm"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.317,
    height: 11.6167,
    rx: 5.80833,
    transform: "matrix(0.757934 -0.652331 -0.652331 -0.757934 96.0459 121.252)",
    fill: "#1792B9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand",
    d: "M102.494 81.4388L116.669 88.2109C116.669 88.2109 124.75 92.3588 110.399 94.2811C104.75 92.8588 107.661 97.2239 108.242 97.8588L119.074 103.004C121.931 106.127 121.876 110.856 118.936 113.545L117.931 114.465C117.863 115.978 117.4 118.422 115.341 120.306C113.83 121.689 112.09 122.181 110.67 122.328C110.405 123.723 109.753 125.418 108.242 126.801C106.19 128.678 103.707 128.929 102.194 128.862C102.194 128.862 96.6067 129.923 93.7499 126.801L69.2499 118.359C64.009 112.63 70.6312 99.2696 76.0111 94.3478L88.2499 88.2109C90.5516 86.1052 99.3321 81.7413 102.494 81.4388Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4961 135.04C82.5211 135.026 85.4863 131.27 84.5647 127.352L78.7434 102.602C77.6889 98.1188 77.137 92.2572 72.6896 93.4532C69.4304 94.3297 64.1347 96.4096 55.6329 100.594L30.306 111.615C25.5282 113.694 21.9971 117.97 21.5909 123.164C20.648 135.222 22.0987 154.798 44.5138 140.699C52.9616 135.386 58.5318 132.542 62.164 131.22C66.6804 129.575 73.6897 135.055 78.4961 135.04Z",
    fill: "url(#scanning3_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconRight",
    d: "M159.32 44.2843C161.094 45.5258 163.512 45.2185 164.921 43.5724L184.854 20.2796C186.553 18.2938 186.155 15.2594 184.001 13.7813V13.7813C182.153 12.5125 179.652 12.8545 178.21 14.5734L158.502 38.06C156.899 39.97 157.279 42.8557 159.32 44.2843V44.2843Z",
    fill: "#E36667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "iconLeft",
    d: "M158.975 14.1802C157.445 15.7117 157.328 18.146 158.704 19.819L178.182 43.4942C179.842 45.5127 182.899 45.6477 184.729 43.7833V43.7833C186.3 42.183 186.397 39.6607 184.955 37.9419L165.247 14.4553C163.644 12.5452 160.737 12.4177 158.975 14.1802V14.1802Z",
    fill: "#E36667"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "scanning0_linear",
    x1: 157.581,
    y1: 98.9263,
    x2: 169.513,
    y2: 115.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338984"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "scanning1_linear",
    x1: 181.051,
    y1: 97.7528,
    x2: 181.05,
    y2: 123.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28D859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338984"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "scanning2_linear",
    x1: 150.824,
    y1: 144.347,
    x2: 189.55,
    y2: 143.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64B5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A80A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "scanning3_linear",
    x1: 81.7245,
    y1: 115.283,
    x2: 60.2729,
    y2: 120.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0B1C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36667"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanning);
export default __webpack_public_path__ + "static/media/scanning.9d447a2b.svg";
export { ForwardRef as ReactComponent };